idp = {}

idp.DB_NAME = 'IAM';
idp.DB_VERSION = 1;
idp.DB_STORE_NAME = 'errors';

idp.OPEN_ERROR = 'OPEN_ERROR';
idp.ADD_ERROR = 'ADD_ERROR';
idp.CLEAR_ERROR = 'CLEAR_ERROR';
idp.DB_NOT_DEFINED = 'DB_NOT_DEFINED';
idp.ERROR_ID_NOT_EXIST = 'ERROR_ID_NOT_EXIST';

idp.READ_WRITE_MODE = 'readwrite';

idp.db = null;

idp.processIAMError = function (errorId) {
    if (!errorId) {
        return idp.ERROR_ID_NOT_EXIST;
    }

    var req = indexedDB.open(idp.DB_NAME, idp.DB_VERSION);
    var result = '';
    req.onsuccess = function (evt) {
        // Equal to: db = req.result;
        idp.db = this.result;

        idp.removeOlderEntries();
        result = idp.addIAMError(errorId);
    };
    req.onerror = function (evt) {
        result = idp.OPEN_ERROR;
    };

    req.onupgradeneeded = function (evt) {
        var store = evt.currentTarget.result.createObjectStore(
            idp.DB_STORE_NAME, {keyPath: 'id', autoIncrement: true});

        store.createIndex('errId', 'errId', {unique: true});
        store.createIndex('timestamp', 'timestamp', {unique: false});
    };
    return result;
}

idp.removeOlderEntries = function () {
    var store = idp.getObjectStore(idp.DB_STORE_NAME, idp.READ_WRITE_MODE);
    const range = IDBKeyRange.upperBound(new Date(Date.now() - 15 * 60000));
    store.index("timestamp").openCursor(range).onsuccess = function (e) {
        const cursor = e.target.result;
        if (!cursor) {
            return;
        }
        cursor.delete();
        cursor.continue();
    };
}

idp.getObjectStore = function (store_name, mode) {
    var tx = idp.db.transaction(store_name, mode);
    return tx.objectStore(store_name);
}

idp.addIAMError = function (errorId) {
    var obj = {timestamp: new Date(Date.now()), errId: errorId};
    var result = '';
    var req;

    try {
        req = idp.getObjectStore(idp.DB_STORE_NAME, 'readwrite').add(obj);
    } catch (e) {
        return idp.ADD_ERROR;
    }

    req.onsuccess = function (evt) {
        var allRecords = idp.getObjectStore(idp.DB_STORE_NAME, 'readwrite').getAll();
        allRecords.onsuccess = function () {
            var resultSize = allRecords.result.length;
            if (resultSize >= 3) {
                Common.showElems([$('.support-link-error-page')]);
            } else {
                Common.hideElems([$('.support-link-error-page')]);
            }
        };
    };
    req.onerror = function (err) {
        result = idp.ADD_ERROR;
    };

    return result;
}
